import { render } from "./rooming_tabs.vue?vue&type=template&id=ff47db38"
import script from "./rooming_tabs.vue?vue&type=script&lang=js"
export * from "./rooming_tabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__